import RemobilizationList from "./RemobilizationList";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import { getReMobilization } from "../../../../store/Api/RemobilizationData";
import axios from "axios";

export default function Remobilization() {
  const title = [
    { label: "ReMobilization", link: "/dashboard/remobilization" },
  ];
  const token = localStorage.getItem("nodeToken");
  const dispatch = useDispatch();

  const [trigger, setTrigger] = useState(false);

  useEffect(() => {
    dispatch(setBreadCrumb(title));
    // dispatch(getReMobilization(token));
  }, []);

  const [employeeData, setEmployeeData] = useState();

  const employee = async () => {
    try {
      const response = await nodeinstance.get(
        `demobilization/idleCandidates/${"REMOBILIZE"}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setEmployeeData(response?.data);
        console.log(".........mmmmmm.......", response?.data);
      }
    } catch (error) {
      console.log("error to be seen here....", error);
      dispatch(
        setAppError({
          msg: "Failed to get the data",
        })
      );
    }
  };
  useEffect(() => {
    employee();
  }, [trigger]);

  return (
    <div className={`p-2 `}>
      <RemobilizationList
        list={employeeData} //pass Data Api
        titles={[
          "S.NO.",
          "POINT OF HIRE",
          "EMPLOYEE ID",
          "EMPLOYEE NAME",
          "NATIONALITY",
          "ACTUAL PROFESSION",
          "VISA PROFESSION",
          "TOTAL SALARY",
          "CLIENT",
          "VISA PROVIDER",
          "IQAMA NUMBER",
          "IQAMA EXPIRY DATE",
          "ARRIVAL DATE",
          "MOBILIZATION DATE",
          "DEMOBILIZATION DATE",
          "DEMOBILIZATION COMMENTS",
          "IDLE AGING",
          "STATUS",
          "CHANGE CLIENT, SALARY & OTHERS",
          "SELECT",
        ]}
        setTrigger={setTrigger}
        trigger={trigger}
      />
    </div>
  );
}
